import { BootStage } from "./types";

export const ALL_BOOT_STAGES: BootStage[] = [
	"microkernel",
	"kernel",
	"pre-authentication",
	"authentication",
	"system-preuser",
	"preuser",
	"preuser2",
	"preuser3",
	"preuser4",
	"earlyuser",
	"user",
];
export const CRITICAL_BOOT_STAGES: BootStage[] = ["microkernel", "kernel"];

export const SYSLOG_CHANNEL = "systemManager.systemlog";
export const SHOW_SYSLOG_CHANNEL = "systemManager.showSystemlog";
export const STATUS_CHANNEL_BASE = "systemManager.boot.status";
export const STAGE_CHANNEL = "systemManager.boot.stage";
export const CHECKPOINT_CHANNEL_BASE = "systemManager.checkpoint";
